Application.User = {
    ready: function () {

        var self = this;

        // check user status when Facebook gets available
        if (!$('html').hasClass('facebook')) {
            $(window).bind('facebook', function () {
                self.update();
            });
        } else {
            self.update();
        }

    },
    update: function () {

        var self = this;

        FB.getLoginStatus(function (response) {
            if (response.status === 'connected' &&
                    (!user.loggedIn ||
                            user.data.fbid != response.authResponse.userID)) {
                // the currently logged in user on the server is different from the FB user
                // update user status
                if (typeof link !== 'undefined' && link.facebookLogin) {
                    $.get(link.facebookLogin);
                }
            } else if (response.status !== 'connected' &&
                    user.loggedIn) {
                // there is a user logged in on server, but the FB user has logged out
                // log out on server as well
                if (typeof link !== 'undefined' && link.facebookLogout) {
                    $.get(link.facebookLogout);
                }
            }
        });

    }
};